import { render, staticRenderFns } from "./Click.vue?vue&type=template&id=3ea75bc5&scoped=true&"
import script from "./Click.vue?vue&type=script&lang=js&"
export * from "./Click.vue?vue&type=script&lang=js&"
import style0 from "./Click.vue?vue&type=style&index=0&id=3ea75bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea75bc5",
  null
  
)

export default component.exports